import Fetch from '../../../mixins/Fetch'

const changeComponent = ({ commit }, step) => {
  commit('CHANGE', step)
}

const changeFields = ({ commit }, fields) => {
  commit('SETFIELDS', fields)
}

const setServicos = ({ commit }, servicos) => {
  commit('SETSERVICOS', servicos)
}

const setModalidadesEntrega = ({ commit }, modalidades) => {
  commit('SETMODALIDADESENTREGA', modalidades)
}

const cleanFieldsAction = ({ commit }) => {
  commit('SETCLEARFIELDS')
}

const loadRegions = ({ commit }) => {
  const request = Fetch.get('regions/get')

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const list = []

  try {
    result.then(data => data.map(d => list.push({ value: d.id, text: d.nome })))
  } catch (e) {
    result.map(d => list.push({ value: d.id, text: d.nome }))
  }

  commit('SETREGIONS', list)
}

const loadInfoCliente = async ({ commit }) => {
  const request = await Fetch.get('infoCliente/getbyiduser')

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const downloadFile = async ({ commit }, id) => {
  const request = await Fetch.get('formpattern/downloadfile', id, 'blob')

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const downloadManual = async ({ commit }) => {
  const request = await Fetch.get('archive/manual', null, 'blob')

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const saveNPS = async ({ _ }, dados) => {
  const request = await Fetch.post('solicitation/addnps', dados)

  if (request.status === 'error') throw new Error(request.message)
  return request
}

const setNameLabels = ({ commit, getters }, name) => {
  const checkSanitarySewageCertificate = getters.getLabels.isNotSanitarySewageCertificate
  let reset = false
  const labels = {
    isNotSanitarySewageCertificate: true,
    tituloDocCliente: 'Documentos pessoa física/jurídica ',
    tituloDocEmpreend: 'Documentos do empreendimento',
    nomeEmpreendimento: 'Nome empreendimento',
    unidadesHabitacionais: 'Número unidades habitacionais',
    previsaoDeLancamento: 'Início do empreendimento',
    previsaoDeConclusao: 'Previsão da entrega do empreendimento'
  }

  if (name === 'Certidão de Esgotamento Sanitário') {
    labels.isNotSanitarySewageCertificate = false
    labels.tituloDocCliente = 'Documentos da empresa/solicitante'
    labels.tituloDocEmpreend = 'Documentos do empreendimento'
    labels.nomeEmpreendimento = 'Razão Social'
    labels.unidadesHabitacionais = 'Área construída'
    labels.previsaoDeLancamento = 'Futuras instalações'
    labels.previsaoDeConclusao = 'Reserva para sistema de tratamento de água residuais'
    reset = true
  } else {
    if (!checkSanitarySewageCertificate) {
      reset = true
    }

    labels.isNotSanitarySewageCertificate = true
    labels.tituloDocCliente = 'Documentos pessoa física/jurídica '
    labels.tituloDocEmpreend = 'Documentos do empreendimento'
    labels.nomeEmpreendimento = 'Nome empreendimento'
    labels.unidadesHabitacionais = 'Número unidades habitacionais'
    labels.previsaoDeLancamento = 'Início do empreendimento'
    labels.previsaoDeConclusao = 'Previsão da entrega do empreendimento'
  }

  commit('SETLABELS', labels)
  return reset
}

export default {
  setModalidadesEntrega,
  cleanFieldsAction,
  changeComponent,
  loadInfoCliente,
  downloadManual,
  downloadFile,
  changeFields,
  setServicos,
  loadRegions,
  saveNPS,
  setNameLabels
}
